import {createContext} from "react";

/**
 * The on-demand blocks (components/sections/index.tsx) that a render draws, by name. Only the server provides it: it gives the list to the browser with the page
 * (utils/onDemandBlocks.ts) so that the browser loads their modules BEFORE it hydrates. In the browser the value is null.
 */
export const UsedBlocksContext = createContext<Set<string> | null>(null);
